import { FormProvider } from "react-hook-form";
import { Input } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils/cn";

export const VerifyMfaForm = ({
    methods,
    onSubmit,
    isPending,
    className = "",
}) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className={cn(
                    "col-span-full grid max-w-6xl grid-cols-subgrid gap-y-6 md:gap-x-8 md:gap-y-3 lg:col-span-6",
                    className,
                )}
            >
                <div className="col-span-full grid grid-cols-subgrid gap-y-4 lg:col-span-6">
                    <div className="col-span-full md:col-span-4 lg:col-span-3">
                        <Input name="code" label="Code" placeholder="xxxxxx" />
                    </div>
                    <div className="col-span-full md:col-span-4 lg:col-span-3">
                        <Button
                            type="submit"
                            variant="primary"
                            className="md:mt-7"
                            disabled={isPending}
                        >
                            Confirm
                        </Button>
                    </div>
                </div>
            </form>
        </FormProvider>
    );
};
